module.exports = __webpack_public_path__ + "static/media/php.4ba6033e.svg";